import { useMatch, useNavigate } from 'react-router-dom';
import { gql, useQuery } from 'urql';
import { FetchLeaguesForSelectorQuery, FetchLeaguesForSelectorQueryVariables } from '../../generated/hooks';

const fetchLeaguesForSelector = gql`
  query fetchLeaguesForSelector {
    leagues {
      id
      name
      season
      leagueType
      userIsCommissioner
    }
  }
`;

// Shared by the desktop LeagueSelector dropdown and the mobile BrandMenu -- both need the same
// league list, current-league detection, and navigate-with-state behavior.
export function useLeagueSelectorItems() {
  const navigate = useNavigate();
  const [{ data }] = useQuery<FetchLeaguesForSelectorQuery, FetchLeaguesForSelectorQueryVariables>({
    query: fetchLeaguesForSelector,
  });
  const leagueId = useMatch('/league/:leagueId/*')?.params.leagueId;

  const leagues = data?.leagues ?? [];
  const currentLeague = leagues.find(league => league.id === leagueId);

  const navigateToLeague = (league: typeof leagues[number]) => {
    navigate(`/league/${league.id}`, {
      state: {
        leagueName: league.name,
        leagueType: league.leagueType,
        season: league.season,
      },
    });
  };

  return { leagues, currentLeague, leagueId, navigateToLeague };
}
